/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Backup_Not_ConfiguredInputs */

const en_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic backup not configured or there were issues saving your backup project.`)
};

const fr_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique non configurée ou problème lors de l’enregistrement du projet de sauvegarde.`)
};

const de_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Datensicherung ist nicht konfiguriert oder es gab Probleme beim Speichern Ihres Sicherungsprojekts.`)
};

const it_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup automatico non configurato oppure si sono verificati problemi durante il salvataggio del progetto di backup.`)
};

const ru_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое резервное копирование не настроено или возникли проблемы при сохранении проекта резервной копии.`)
};

const es_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La copia de seguridad automática no está configurada o hubo problemas al guardar el proyecto de copia de seguridad.`)
};

const zh_cn2_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份未配置，或者保存备份项目时出现问题。`)
};

const ja_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップが構成されていないか、バックアップ プロジェクトの保存中に問題が発生しました。`)
};

const hi_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप कॉन्फ़िगर नहीं किया गया है या आपके बैकअप प्रोजेक्ट को सहेजने में समस्याएँ थीं।`)
};

const pt_pt2_automatic_save_backup_not_configured = /** @type {(inputs: Automatic_Save_Backup_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O backup automático não está configurado ou ocorreram problemas ao salvar seu projeto de backup.`)
};

/**
* | output |
* | --- |
* | "Automatic backup not configured or there were issues saving your backup project." |
*
* @param {Automatic_Save_Backup_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_backup_not_configured = /** @type {((inputs?: Automatic_Save_Backup_Not_ConfiguredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Backup_Not_ConfiguredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_backup_not_configured(inputs)
	if (locale === "de") return de_automatic_save_backup_not_configured(inputs)
	if (locale === "it") return it_automatic_save_backup_not_configured(inputs)
	if (locale === "ru") return ru_automatic_save_backup_not_configured(inputs)
	if (locale === "es") return es_automatic_save_backup_not_configured(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_backup_not_configured(inputs)
	if (locale === "ja") return ja_automatic_save_backup_not_configured(inputs)
	if (locale === "hi") return hi_automatic_save_backup_not_configured(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_backup_not_configured(inputs)
	return en_automatic_save_backup_not_configured(inputs)
});